import Cookies from 'js-cookie';
import { encrypt } from './encryption';
import { localStorageUtils } from './localStorageUtils';

const { STORAGE_KEYS, saveToLocalStorage, restoreFromLocalStorage } = localStorageUtils;

/**
 * @param {string} name
 * @param {any} data
 * @param {object} cookiesOptions
 * @param {boolean} isNeedEncryption
 */
function createCookies(name, data, cookiesOptions = {}, isNeedEncryption = false) {
    const cookiesData = typeof data === 'object' ? JSON.stringify(data) : String(data);
    const finalData = isNeedEncryption ? encrypt(cookiesData) : cookiesData;

    Cookies.set(name, finalData, cookiesOptions);

    if (name === 'user') {
        saveToLocalStorage(STORAGE_KEYS.USER, data);
    } else if (name === 'tokens') {
        saveToLocalStorage(STORAGE_KEYS.TOKENS, data);
    }
}

function getCookies() {
    const allCookies = Cookies.get();

    if (Object.keys(allCookies).length > 0) {
        const parsedCookies = {};

        for (const key in allCookies) {
            const value = allCookies[key];
            try {
                parsedCookies[key] = JSON.parse(value);
            } catch {
                parsedCookies[key] = value;
            }
        }

        return parsedCookies;
    }

    const restored = restoreFromLocalStorage();

    if (restored) {
        createCookies(
            'user',
            restored.user,
            {
                sameSite: 'none',
                secure: true,
                expires: 7,
            },
            false
        );

        createCookies(
            'tokens',
            restored.tokens,
            {
                sameSite: 'none',
                secure: true,
                expires: 7,
            },
            false
        );

        return {
            user: restored.user,
            tokens: restored.tokens,
        };
    }

    return null;
}

export const cookieUtils = {
    createCookies,
    getCookies,
};
